const listeners = new Set();
let pendingCategoryId = null;

const activeListeners = new Set();
let activeCategoryId = null;

const dialogOpenListeners = new Set();
let settingsDialogOpen = false;

const hostListeners = new Set();

/**
 * Subscribe when the headless OrganizationSettings host should mount.
 * @param {() => void} callback
 * @returns {() => void} unsubscribe
 */
export function onOrgSettingsHostNeeded(callback) {
  hostListeners.add(callback);
  return () => hostListeners.delete(callback);
}

/** Mount the headless OrganizationSettings host (LandingPage). */
export function requestOrgSettingsHost() {
  hostListeners.forEach((cb) => cb());
}

/**
 * Subscribe to organization-setting open requests (e.g. from app header menu).
 * @param {(categoryId: string) => void} callback
 * @returns {() => void} unsubscribe
 */
export function onOrganizationSettingOpen(callback) {
  listeners.add(callback);
  if (pendingCategoryId) {
    const id = pendingCategoryId;
    pendingCategoryId = null;
    callback(id);
  }
  return () => listeners.delete(callback);
}

/**
 * Open an organization settings category dialog without navigating away.
 * @param {string} categoryId
 */
export function openOrganizationSetting(categoryId) {
  if (!categoryId) return;
  requestOrgSettingsHost();
  setOrganizationSettingActive(categoryId);
  if (listeners.size === 0) {
    pendingCategoryId = categoryId;
    return;
  }
  listeners.forEach((cb) => cb(categoryId));
}

/**
 * Track the last-opened / active settings category (for menu highlight).
 * @param {string|null|undefined} categoryId
 */
export function setOrganizationSettingActive(categoryId) {
  activeCategoryId = categoryId || null;
  activeListeners.forEach((cb) => cb(activeCategoryId));
}

/**
 * @param {(categoryId: string|null) => void} callback
 * @returns {() => void} unsubscribe
 */
export function onOrganizationSettingActive(callback) {
  activeListeners.add(callback);
  callback(activeCategoryId);
  return () => activeListeners.delete(callback);
}

/**
 * Track whether an org settings detail dialog is open (keeps header menu persistent).
 * @param {boolean} open
 */
export function setOrganizationSettingDialogOpen(open) {
  settingsDialogOpen = !!open;
  dialogOpenListeners.forEach((cb) => cb(settingsDialogOpen));
}

/**
 * @param {(open: boolean) => void} callback
 * @returns {() => void} unsubscribe
 */
export function onOrganizationSettingDialogOpen(callback) {
  dialogOpenListeners.add(callback);
  callback(settingsDialogOpen);
  return () => dialogOpenListeners.delete(callback);
}
